import { Card } from 'antd';
import type { FC } from 'react';
import { useDepartments } from '@/common/useDepartments';
import type { GetOrderHistoryQuery } from '@/generated/graphql/graphql';
import dayjs from '@/utils/dayjs-instance';
import { RowView } from './components/RowChangeView';

export const OrderUserViewsLogView: FC<{
  userViewsLog: GetOrderHistoryQuery['user_views_log'][0];
}> = ({ userViewsLog }) => {
  const { selectedDepartment } = useDepartments();
  const createdAtWithTimezone = dayjs
    .utc(userViewsLog.createdAt)
    .utcOffset((selectedDepartment?.timeZone || 0) * 60);
  const createdAtDate = createdAtWithTimezone.format('DD, MMM');
  const createdAtTime = createdAtWithTimezone.format('HH:mm');
  const userName = userViewsLog.user.name;

  return (
    <div style={{ padding: '4px 8px' }}>
      <Card
        style={{ padding: 0 }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{userName ?? 'admin'}</span>
            <div>
              <span style={{ color: '#1890ffaa', fontWeight: 400, fontSize: 14 }}>
                {createdAtDate}{' '}
              </span>
              <span style={{ color: '#1890ff' }}>{createdAtTime}</span>
            </div>
          </div>
        }
      >
        <div style={{ padding: 2 }}>
          <span>{RowView('Viewed client phone number')}</span>
        </div>
      </Card>
    </div>
  );
};
